import { render } from "./market-asks-block.vue?vue&type=template&id=11a126d3&scoped=true"
import script from "./market-asks-block.vue?vue&type=script&lang=js"
export * from "./market-asks-block.vue?vue&type=script&lang=js"

import "./market-asks-block.vue?vue&type=style&index=0&id=11a126d3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a126d3"]])

export default __exports__